import { Mail } from 'iconoir-react';
import { Avatar } from '@/components/ui/avatar';

/**
 * Mail-glyph avatar for a raw-email recipient (no profile picture): the shared
 * Avatar wrapper's `icon` fallback on a muted tile. Used by the picker's email
 * row and the modal's selected-recipient chip.
 */
export const EmailGlyphAvatar = () => (
  <Avatar size="sm" icon={<Mail width={16} height={16} />} bg="bg.muted" color="fg.muted" />
);
